//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import moment from 'moment-timezone';
import React from 'react';
import { useSelector } from 'react-redux';

import { PurchaseOption } from '@apis/campaign-requests/sampling/opportunities/samplingOpportunitiesApiModel';
import { PurchaseOptionsTableRowContent } from '@campaigns/components/shared/purchase-options/purchase-options-table-row/PurchaseOptionsTableRowContent';
import { getExpiryBadgeType } from '@campaigns/utils/sampling/samplingCampaignsPurchaseOptionsUtils';
import { TableRow } from '@components/organisms/table/TableRow';
import { getUserTimeZone } from '@redux/selectors/getUserTimeZone';

interface PurchaseOptionsTableRowReadOnlyProps {
  purchaseOption: PurchaseOption;
}

export const PurchaseOptionsTableRowReadOnly = ({
  purchaseOption,
}: PurchaseOptionsTableRowReadOnlyProps) => {
  const timeZone = useSelector(getUserTimeZone);

  const isExpired = moment(purchaseOption.expiryDate).isBefore(moment());
  const expiryBadgeInfo = getExpiryBadgeType(
    purchaseOption.expiryDate,
    timeZone,
  );

  return (
    <TableRow>
      <PurchaseOptionsTableRowContent
        expiryBadgeInfo={expiryBadgeInfo}
        isExpired={isExpired}
        purchaseOption={purchaseOption}
      />
    </TableRow>
  );
};
